export default __webpack_public_path__ + "static/media/twitter.80d20bc4.svg";